export const ERROR_STATUS_KEYS = [
  'NOT_FOUND',
  'BAD_REQUEST',
  'NOT_ACCEPTABLE',
  'INTERNAL_SERVER_ERROR',
];

export const ERROR_PDB_STATUS_KEYS = [
  'UNBUILDABLE',
  'STOCKITEM_NOT_FULLY_AVAILABLE',
  'STOCK_VEHICLE_UNAVAILABLE',
  'OPTIONS_UNAVAILABLE',
];
